var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-2" },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.voucherGetting } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64", color: "white" }
          })
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "green",
                    dark: "",
                    dense: "",
                    loading: _vm.ptCashVoucherStorePosting
                  },
                  on: { click: _vm.storePtCashVoucher }
                },
                [_c("span", [_vm._v("Submit PT")])]
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    dark: "",
                    color: "purple",
                    dense: "",
                    flat: "",
                    loading: _vm.ptCashVoucherStorePosting
                  }
                },
                [
                  _c("span", [_vm._v("PT Voucher Form")]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", color: "green", dense: "" },
                      on: {
                        click: function($event) {
                          _vm.createSupplier = true
                        }
                      }
                    },
                    [_vm._v("New Supplier")]
                  )
                ],
                1
              ),
              _c(
                "v-card",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Voucher",
                                  value: _vm.voucherData.voucher_no,
                                  "hide-details": "auto"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Pay To",
                                  "item-value": "id",
                                  "item-text": "name",
                                  "search-input": _vm.payToListSearch,
                                  items: _vm.payToListList,
                                  loading: _vm.payToListGetting,
                                  clearable: "",
                                  "error-messages":
                                    _vm.ptCashVoucherStorePostErrors.pay_to,
                                  "no-filter": "",
                                  "return-object": "",
                                  "hide-details": "auto"
                                },
                                on: {
                                  "update:searchInput": function($event) {
                                    _vm.payToListSearch = $event
                                  },
                                  "update:search-input": function($event) {
                                    _vm.payToListSearch = $event
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item",
                                    fn: function({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "primary--text" },
                                          [_vm._v(_vm._s(item.id))]
                                        ),
                                        _c(
                                          "small",
                                          {
                                            staticClass: "blue-grey--text ml-2"
                                          },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                        _c(
                                          "small",
                                          {
                                            staticClass: "blue-grey--text ml-2"
                                          },
                                          [
                                            _vm._v(
                                              "(" + _vm._s(item.type) + ")"
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.payToObject,
                                  callback: function($$v) {
                                    _vm.payToObject = $$v
                                  },
                                  expression: "payToObject"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Address",
                                  "hide-details": "auto",
                                  "error-messages":
                                    _vm.ptCashVoucherStorePostErrors.address
                                },
                                model: {
                                  value: _vm.address,
                                  callback: function($$v) {
                                    _vm.address = $$v
                                  },
                                  expression: "address"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Paid By",
                                  "hide-details": "auto",
                                  value: _vm.voucherData.paid_by
                                    ? _vm.voucherData.paid_by.description
                                    : null,
                                  readonly: ""
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Date",
                                  type: "date",
                                  "hide-details": "auto",
                                  "error-messages":
                                    _vm.ptCashVoucherStorePostErrors.date
                                },
                                model: {
                                  value: _vm.date,
                                  callback: function($$v) {
                                    _vm.date = $$v
                                  },
                                  expression: "date"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Balance",
                                  "hide-details": "auto",
                                  value: (
                                    _vm.voucherBalance - _vm.totalAmount
                                  ).phpFormat(),
                                  readonly: ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "2" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "purple", flat: "" } },
                [_c("span", [_vm._v("PT Breakdown Form")])]
              ),
              _c(
                "v-card",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-switch", {
                                attrs: {
                                  label: "Revolving Funds",
                                  "hide-details": "auto"
                                },
                                model: {
                                  value: _vm.revolvingFunds,
                                  callback: function($$v) {
                                    _vm.revolvingFunds = $$v
                                  },
                                  expression: "revolvingFunds"
                                }
                              }),
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Account Code",
                                  items: _vm.accountCodes,
                                  "item-value": "account_code.id",
                                  "item-text": "account_code.description",
                                  "hide-details": "auto",
                                  "error-messages":
                                    _vm.ptCashVoucherStorePostErrors
                                      .account_code_id
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item",
                                    fn: function({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          { staticClass: "primary--text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.account_code.account_code
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "small",
                                          {
                                            staticClass: "ml-2 blue-grey--text"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.account_code.description
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.accountCodeId,
                                  callback: function($$v) {
                                    _vm.accountCodeId = $$v
                                  },
                                  expression: "accountCodeId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Description",
                                  "hide-details": "auto",
                                  "error-messages":
                                    _vm.voucherDetailVerifyPostErrors
                                      .description
                                },
                                model: {
                                  value: _vm.description,
                                  callback: function($$v) {
                                    _vm.description = $$v
                                  },
                                  expression: "description"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Amount",
                                  type: "number",
                                  "hide-details": "auto",
                                  "error-messages":
                                    _vm.voucherDetailVerifyPostErrors.amount
                                },
                                model: {
                                  value: _vm.amount,
                                  callback: function($$v) {
                                    _vm.amount = _vm._n($$v)
                                  },
                                  expression: "amount"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "green",
                                    dark: "",
                                    block: "",
                                    loading: _vm.voucherDetailVerifyPosting
                                  },
                                  on: { click: _vm.addDetail }
                                },
                                [_c("span", [_vm._v("add")])]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", flat: "", dense: "", color: "purple" } },
                [_c("span", [_vm._v("PT Breakdown")])]
              ),
              _c(
                "v-card",
                [
                  _c(
                    "v-container",
                    [
                      _c("v-simple-table", {
                        attrs: { dense: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [_vm._v("Item")]),
                                    _c("th", [_vm._v("Account Code")]),
                                    _c("th", [_vm._v("Descrition")]),
                                    _c("th", [_vm._v("Amount")]),
                                    _c("th", [_vm._v("Config")])
                                  ])
                                ]),
                                _c(
                                  "tbody",
                                  [
                                    _vm._l(_vm.details, function(item, index) {
                                      return _c("tr", { key: index }, [
                                        _c("td", [_vm._v(_vm._s(index + 1))]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.accountCodeCode(
                                                item.account_code_id
                                              )
                                            )
                                          )
                                        ]),
                                        _c("td", [
                                          _vm._v(_vm._s(item.description))
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              (item.amount || 0).phpFormat()
                                            )
                                          )
                                        ]),
                                        _c(
                                          "td",
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "error",
                                                  text: "",
                                                  small: "",
                                                  dense: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeItem(index)
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-delete")
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    }),
                                    _c("tr", [
                                      _c("th", { attrs: { colspan: "3" } }, [
                                        _vm._v("Total")
                                      ]),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(_vm.totalAmount.phpFormat())
                                        )
                                      ])
                                    ])
                                  ],
                                  2
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "1200px", persistent: "" },
          model: {
            value: _vm.createSupplier,
            callback: function($$v) {
              _vm.createSupplier = $$v
            },
            expression: "createSupplier"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: "primary",
                    dark: "",
                    dense: "",
                    tile: "",
                    flat: ""
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      on: {
                        click: function($event) {
                          _vm.createSupplier = false
                        }
                      }
                    },
                    [_vm._v("mdi-close")]
                  )
                ],
                1
              ),
              _c("v-container", [_c("create-supplier")], 1)
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }